import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { TranslateModule } from '@ngx-translate/core'

import { MultiVisitReviewTotals } from '../../../services/estimate-balance-presenter.service'

@Component({
  selector: 'mmx-balance-grand-total-bar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, MatCardModule],
  templateUrl: './balance-grand-total-bar.component.html',
  styleUrls: ['./balance-grand-total-bar.component.scss'],
})
export class BalanceGrandTotalBarComponent {
  @Input() totals: MultiVisitReviewTotals = { patientResp: 0, insuranceResp: 0, total: 0 }
}
